import React from 'react'
import ServiceKeyValueCard, {
    TServiceKeyValueItem,
} from './ServiceKeyValueCard'

type TProps = {
    items: TServiceKeyValueItem[]
    className?: string
}

const ServiceAdditionalDetails: React.FC<TProps> = ({
    items,
    className = '',
}) => {
    if (!items.length) {
        return null
    }

    return (
        <div className={className} data-testid="service-additional-details">
            <ServiceKeyValueCard title="Additional details" items={items} />
        </div>
    )
}

export default ServiceAdditionalDetails
